import { render, staticRenderFns } from "./ShowUserCardMobile.vue?vue&type=template&id=e2b565da&scoped=true"
import script from "./ShowUserCardMobile.vue?vue&type=script&lang=js"
export * from "./ShowUserCardMobile.vue?vue&type=script&lang=js"
import style0 from "./ShowUserCardMobile.vue?vue&type=style&index=0&id=e2b565da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b565da",
  null
  
)

export default component.exports